import React from 'react';
import PropTypes from 'prop-types';

import styles from './DigitInput.scss';

const DigitInput = ({ value, selected }) => (
  <div className={`${styles.DigitInput} ${selected ? styles.selected : ''}`}>
    {value}
  </div>
);

DigitInput.defaultProps = {
  selected: false
};

DigitInput.propTypes = {
  value: PropTypes.number.isRequired,
  selected: PropTypes.bool
};

export default DigitInput;



// WEBPACK FOOTER //
// ./src/components/DigitInput/DigitInput.js